<script>
	import { tippy_action } from "./tippy";

	export let copy_value;
	export let style;

	let tooltip_message = "Copy to clipboard";

	function copy() {
		navigator.clipboard.writeText(copy_value);
		tooltip_message = "Copied!";
		// after 2 seconds, hide the tooltip
		setTimeout(() => {
			tooltip_message = "Copy to clipboard";
		}, 2000);
	}
</script>

<button
	on:click|stopPropagation={copy}
	use:tippy_action={{ content: tooltip_message, hideOnClick: false }}
	{style}
>
	<slot />
</button>
